import { useTranslation } from '../../core/hooks/use-translation';
import type { PortalAppointment } from '../../core/models/portal-appointment';
import { EmptyState } from '../../ui/empty-state';
import { CalendarIcon } from '../../ui/portal-icons';
import { AppointmentCard } from './appointment-card';

/**
 * A case's meetings, what is ahead above what is behind. The "earlier" heading appears only when
 * there is something ahead to separate it from — alone, it would label the obvious.
 */
export function CaseAppointmentList({
    upcoming,
    earlier,
    onCancelled
}: {
    upcoming: readonly PortalAppointment[];
    earlier: readonly PortalAppointment[];
    onCancelled: (appointmentId: string) => void;
}) {
    const { t } = useTranslation();

    if (upcoming.length === 0 && earlier.length === 0) {
        return (
            <EmptyState compact icon={<CalendarIcon />} title={t('portal.no_appointments')}>
                {t('portal.no_appointments_hint')}
            </EmptyState>
        );
    }

    return (
        <div className="space-y-5">
            {upcoming.length > 0 && (
                <ul className="space-y-3">
                    {upcoming.map((appointment) => (
                        <AppointmentCard key={appointment.id} appointment={appointment} onCancelled={onCancelled} />
                    ))}
                </ul>
            )}

            {earlier.length > 0 && (
                <div>
                    {upcoming.length > 0 && (
                        <h3 className="mb-3 text-xs font-semibold tracking-wider text-slate-500 uppercase dark:text-slate-400">
                            {t('portal.earlier_appointments')}
                        </h3>
                    )}

                    <ul className="space-y-3">
                        {earlier.map((appointment) => (
                            <AppointmentCard key={appointment.id} appointment={appointment} onCancelled={onCancelled} />
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
}
